import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'empathy-duplicate-questions-dialog',
  templateUrl: 'duplicate-questions-dialog.component.html',
  styleUrl: './duplicate-questions-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DuplicateQuestionsDialogComponent implements OnInit {
  faExclamationCircle = faExclamationCircle;

  constructor(
    private dialogRef: MatDialogRef<DuplicateQuestionsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { questionsCount: number; questionsWithConditionsCount: number; activeQuestionCode: string; hasTranslations: boolean }
  ) {}

  ngOnInit(): void {
    this.dialogRef.addPanelClass('empathy-confirm__dialog');
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
